var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _class, _class2, _descriptor, _descriptor2;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
import { Component, Prop, Event, html, styleMap } from '@sick-davinci/ce-decorators';
import { style } from '../slider/Slider.style';
import { AbstractSlider } from '../slider/AbstractSlider';
/**
 * A `davinci-range-slider` can be used to define a value range.
 *
 * @example
 * ```html
 * <davinci-range-slider icon-left="av/volume_mute" value="[25,75]" icon-right="av/volume_up" style="margin-top:40px"></davinci-range-slider>
 * ```
 *
 * @slot {*} title of the slider
 */

export let RangeSlider = (_dec = Component({
  tag: 'davinci-range-slider',
  style: [style],
  dependencies: [AbstractSlider]
}), _dec2 = Prop({
  reflectAsAttribute: true
}), _dec3 = Reflect.metadata("design:type", Object), _dec4 = Event(), _dec5 = Reflect.metadata("design:type", Object), _dec6 = Event(), _dec7 = Reflect.metadata("design:type", Object), _dec(_class = (_class2 = class RangeSlider extends AbstractSlider {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "change", _descriptor, this);

    _initializerDefineProperty(this, "input", _descriptor2, this);

    _defineProperty(this, "_valueHasChanged", false);

    _defineProperty(this, "keyDownEvent", event => {
      if (this.showValueField) {
        return;
      }

      if (this.KEY_CODE_ARROW_UP.includes(event.key) || this.KEY_CODE_ARROW_RIGHT.includes(event.key)) {
        this.updateValueAndEmit(this.increment(), true, false);
        event.preventDefault();
      } else if (this.KEY_CODE_ARROW_DOWN.includes(event.key) || this.KEY_CODE_ARROW_LEFT.includes(event.key)) {
        this.updateValueAndEmit(this.decrement(), true, false);
        event.preventDefault();
      } else if (!this.disabled && this.value.length > 1) {
        if (event.shiftKey && event.key === this.KEY_CODE_TAB) {
          if (this.lastPickedKnob === 1) {
            this.updateKnobSelectionTo('0');
          } else {
            // Continue with default shift+tab action
            return;
          }
        } else if (event.key === this.KEY_CODE_TAB) {
          if (this.lastPickedKnob === 0) {
            this.updateKnobSelectionTo('1');
          } else {
            // Continue with default tab action
            return;
          }
        }

        event.preventDefault();
        event.stopPropagation();
      }
    });

    _defineProperty(this, "_keyUpEvent", event => {
      if (this.KEY_CODE_ARROW_UP.includes(event.key) || this.KEY_CODE_ARROW_RIGHT.includes(event.key) || this.KEY_CODE_ARROW_DOWN.includes(event.key) || this.KEY_CODE_ARROW_LEFT.includes(event.key)) {
        this.updateValueAndEmit(this.lastPickedKnob === 0 ? this.value[0] : this.value[1], false, true);
        event.preventDefault();
      }
    });
  }

  /**
   * Current value.
   * First array element is the lower value, second array element is the upper value.
   * It may be the case that there is only one element.
   */
  set value(newValue) {
    this._value = newValue;
    this.updateState();
  }

  get value() {
    return this._value;
  }
  /**
   * Emitted [Array<Number>] if the value changes.
   * First array element is the lower value, second array element is the upper value.
   */


  /**
   * The get/set relativeValues wrapper keeps the API stable after refactoring.
   * <br/>
   * DEPRECATED: please use the {@link value} instead.
   * @deprecated
   */
  get relativeValues() {
    return this.knobPositions;
  }

  set relativeValues(newValue) {
    this.knobPositions = newValue; // The knob position should never be changed via a call to this setter.
    // The knob position may only be changed when the values of this slider change.

    console.warn('Do not change the relativeValues-property. Please use the value-property instead.'); // tslint:disable-line
  }

  render() {
    return this.renderSlider(this.value);
  }

  componentConnected() {
    super.componentConnected();
    this.addEventListener('keyup', this._keyUpEvent);
  }

  componentDisconnected() {
    super.componentDisconnected();
    this.removeEventListener('keyup', this._keyUpEvent);
    this.removeMouseListenersForKnob(this._elementKnob1);
  }
  /**
   * @override
   */


  maintainDomReferences() {
    super.maintainDomReferences();
    this.removeMouseListenersForKnob(this._elementKnob1);
    this._elementKnob1 = this.shadowRoot.querySelector('[data-id="1"]');
    this.addMouseListenersForKnob(this._elementKnob1);
  }
  /**
   * @override
   */


  renderSpecific() {
    return this.value.length > 1 ? this._addKnob1() : html``;
  }
  /**
   * @override
   */


  /**
   * @override
   */
  updateValueAndEmit(value, emitInput, emitChange) {
    // The input event is processed first, so we need to store whether the
    // value has changed in order to be able to retrieve that information
    // when the change event is processed later on.
    this._updateValue(value); // this.value is valid at this point


    if (emitInput) {
      this.input.emit(this.value);
    }

    if (emitChange && this._valueHasChanged) {
      this._valueHasChanged = false;
      this.change.emit(this.value);
    }
  }
  /**
   * @override
   */


  updateKnobSelectionTo(id) {
    super.updateKnobSelectionTo(id);
    this.removeCurrentKnobClass('focused');

    if (id !== undefined) {
      this.lastPickedKnob = parseInt(id, 0);
    }

    this.addCurrentKnobClass('focused');
  }

  _addKnob1() {
    return html`<div class="knob" style="${styleMap({
      left: this.knobPositions[1] + '%'
    })}"
        @="${this.pressEventDirective(this.downEvent)}" data-id="1"><div class="knob_shadow"></div></div>`;
  }
  /**
   * Updates this slider's value to the position of the last picked knob.
   *
   * @param newValue - the value associated with the last picked knob
   */


  _updateValue(newValue) {
    // Set the complete array so the setter of the value-property is triggered.
    const updatedValue = [...this.value];
    const knobIndex = this.lastPickedKnob;
    updatedValue[knobIndex] = newValue;
    this._valueHasChanged = this.value[knobIndex] !== updatedValue[knobIndex] || this._valueHasChanged;
    this.value = this._validate(updatedValue);
  }

  _updateKnobPositions() {
    this.knobPositions = this.value.map(dataPoint => this.map(dataPoint, this.min, this.max, 0, 100));
  } // ToDo @6.0.0 -> remove method and use onNumericFieldChange() directly

  /**
   * @override
   */


  synchronizeValueFieldValue(index, _initialValue, newValue) {
    this.onNumericFieldChange(newValue[index], index);
  }

  onNumericFieldChange(newValue, index) {
    if (this.value[index] === newValue) {
      this.overwriteInputFieldValue(index, this.value[index]);
    } else {
      const nextValue = [...this.value];
      nextValue[index] = newValue;
      this.value = nextValue;
      this.change.emit(this.value);
    }
  }
  /**
   * @override
   */


  updateSyncedState() {
    if (!Array.isArray(this._value) || !this._value.length) {
      this._value = [this.min, this.max];
    }

    this._value = this._validate(this._value);

    this._updateKnobPositions();
  }

  _getDirection(oldValue, newValue) {
    const knob = this.lastPickedKnob;
    return oldValue[knob] > newValue[knob] ? -1 : oldValue[knob] < newValue[knob] ? 1 : undefined;
  }

  _validate(value) {
    if (value.length < 1) {
      throw new Error('parameter "value" must not be empty');
    }

    if (value.length > 2) {
      throw new Error('parameter "value" must not have more than 2 elements but has ' + value.length);
    }

    const validated = [...value];

    for (let i = 0; i < validated.length; i++) {
      validated[i] = this.validateValue(this.roundWithTicks(validated[i]));
    }

    if (validated.length > 1) {
      // keep values & knobs sorted
      const changeDirection = this._getDirection(this.value, value);

      if (changeDirection === 1 && this.lastPickedKnob === 0 && validated[0] > validated[1]) {
        // avoid pulling left knob past right knob
        validated[0] = validated[1];
      } else if (changeDirection === -1 && this.lastPickedKnob === 1 && validated[0] > validated[1]) {
        // avoid pulling right knob past left knob
        validated[1] = validated[0];
      } else if (validated[0] > validated[1]) {
        // keep value[0] <= value[1]
        validated[1] = validated[0];
      }
    }

    return validated;
  }

}, (_applyDecoratedDescriptor(_class2.prototype, "value", [_dec2, _dec3], Object.getOwnPropertyDescriptor(_class2.prototype, "value"), _class2.prototype), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "change", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "input", [_dec6, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class);
